import apiService from 'apiService'
import React from 'react'
import { toast } from 'react-toastify'

export default function EnableStoreIcon({ storeId, refreshTable }) {
    const handleClick = async () => {
        const payload = {
            enabled: 1
        }
        await apiService.put(`/stores/${storeId}`, payload)
        refreshTable(+Date.now())
        toast.success('Επιτυχής ενεργοποίηση καταστήματος!', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            theme: 'colored'
        })
    }

    return <i title="Ενεργοποίηση Καταστήματος" className="fas fa-store text-emerald-500 mr-2" style={{ cursor: 'pointer' }} onClick={handleClick}></i>
}
